"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.advanceFire = void 0;
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueTester_7drl_2023_1 = require("../scene/rogueTester_7drl_2023");
var rogueMonsters_sidecar_1 = require("./rogueMonsters-sidecar");
// TODO: difficulty balance
var advanceFire = function () {
    var e_1, _a;
    var objs = rogueMonsters_sidecar_1.rogueMonsters.getAll().map(function (c) { return c; });
    var house = (0, rogueTester_7drl_2023_1.getHouse)();
    if (!house) {
        return;
    }
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    try {
        for (var objs_1 = __values(objs), objs_1_1 = objs_1.next(); !objs_1_1.done; objs_1_1 = objs_1.next()) {
            var obj = objs_1_1.value;
            if (obj.isDead) {
                continue;
            }
            if (obj.data.type === 'f') {
                if (rando_sidecar_1.rando.chance(house.difficulty.fireGrowChance)) {
                    var newM = rogueMonsters_sidecar_1.rogueMonsters.create('F');
                    rogueMonsters_sidecar_1.rogueMonsters.setPos(newM, obj.x, obj.y);
                    rogueMonsters_sidecar_1.rogueMonsters.kill(obj);
                }
            }
            if (obj.data.type === 'F') {
                if (rando_sidecar_1.rando.chance(house.difficulty.fireSpreadChance)) {
                    var directions = [
                        { x: -1, y: 0 },
                        { x: 1, y: 0 },
                        { x: 0, y: -1 },
                        { x: 0, y: 1 },
                    ];
                    while (directions.length > 0) {
                        // Spawn new fire
                        var d = rando_sidecar_1.rando.sampleAndRemove(directions);
                        var x = obj.x + d.x;
                        var y = obj.y + d.y;
                        if (rogueMaps_sidecar_1.rogueMaps.isOpen(map, x, y)) {
                            if (rogueMaps_sidecar_1.rogueMaps.isPassible(map, x, y)) {
                                var newM = rogueMonsters_sidecar_1.rogueMonsters.create('f');
                                rogueMonsters_sidecar_1.rogueMonsters.setPos(newM, obj.x + d.x, obj.y + d.y);
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objs_1_1 && !objs_1_1.done && (_a = objs_1.return)) _a.call(objs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.advanceFire = advanceFire;
